export const ACTIONS = {
    SET_DATA: "SET_DATA",
    SET_ERROR: "SET_ERROR",
    SET_LOADING: "SET_LOADING",
};